// https://vuetifyjs.com/en/getting-started/installation/#webpack-install
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

// https://vuetifyjs.com/en/features/theme/
export default new Vuetify({
	defaultAssets: {
		font: false,
		icons: true
	},
	theme: {
		themes: {
			light: {
				primary: '#005E97',
				secondary: '#13799D',
				accent: '#B9D7E5',
				error: '#EB0300',
				info: '#555555',
				//success: '#4e843d',
				success: '#7EB440',
				warning: '#d26e4b'
			}
		}
	}
})
